import { render, staticRenderFns } from "./ManufacturerListCard.vue?vue&type=template&id=6221b000&scoped=true"
import script from "./ManufacturerListCard.vue?vue&type=script&lang=js"
export * from "./ManufacturerListCard.vue?vue&type=script&lang=js"
import style0 from "./ManufacturerListCard.vue?vue&type=style&index=0&id=6221b000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6221b000",
  null
  
)

export default component.exports